export type BypassActor = {
  id?: number
  _id?: number
  actorId: number | string | null
  actorType: BypassActorType
  name: string
  _enabled: boolean
  _dirty: boolean
  bypassMode: ActorBypassMode
  owner?: string
  preferredAvatarUrl?: string
}

export type BypassActorType =
  | 'RepositoryRole'
  | 'Team'
  | 'Integration'
  | 'OrganizationAdmin'
  | 'DeployKey'
  | 'BusinessTeam'
  | 'EnterpriseOwner'
  | 'RepositoryMigration'
  | 'EnterpriseRole'
  | 'User'

export const ActorBypassMode = {
  ALWAYS: 0,
  PRS_ONLY: 1,
  EXEMPT: 2,
} as const

export type ActorBypassMode = (typeof ActorBypassMode)[keyof typeof ActorBypassMode]
